import React, { Fragment, memo } from 'react'
import './Splash.css'
import logo from '../../img/logo.png'
import LOG from '../../logging/Logger'

export default memo(() => {
  LOG.debug('Render: Splash')

  return (
    <Fragment>
      {/* Change this to a spash screen in future */}
      <div className='Splash'>
        <img src={logo} className='Splash-logo' alt='logo' />
      </div>
    </Fragment>
  )
})
